module.exports = __webpack_public_path__ + "static/media/uv.661d815b.svg";